module.exports = __webpack_public_path__ + "img/bottombeer.641a1bd0.png";